import { appRoles } from 'core/constants/constants';

export const getMostPrivilegedRole = (userRoles: string[]) => {
    const orderedRoles = Object.values(appRoles);
    return userRoles.reduce<string | null>((mostPrivileged, userRole) => {
        const userRoleIndex = orderedRoles.indexOf(userRole);
        if (userRoleIndex === -1) {
            return mostPrivileged;
        }
        const currentBestIndex = mostPrivileged === null ? -1 : orderedRoles.indexOf(mostPrivileged);
        return userRoleIndex < currentBestIndex || mostPrivileged === null ? userRole : mostPrivileged;
    }, null);
};
